<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>支社・支局／媒体登録</h1>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" message-key="message.admin.mst.branch.error."/>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>支社・支局／媒体名<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-text-field
            v-model="form.branchName"
            hide-details
            placeholder="支社・支局／媒体名を入力してください"
            solo
            dense
            maxlength="100"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>支社・支局／媒体名カナ</mp-label>
      </v-col>
      <v-col cols="8" outlined tile>
        <mp-input-box>
          <v-text-field
            v-model="form.branchNameKana"
            hide-details
            placeholder="支社・支局／媒体名カナを入力してください"
            solo
            dense
            maxlength="100"
          ></v-text-field>
        </mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goCompanytDetail">戻る</mp-button>
      </v-col>
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="goRegister">登録する</mp-button>
        <mp-dialog regist :show="dialog.registComplete" @clickOk="goCompanytDetail" />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { AdminMstBranch } from '@/api'
import MpLabel from '@/components/item/MpLabel'
import MpInputBox from '@/components/item/MpInputBox'
import MpError from '@/components/item/MpError'
import MpButton from '@/components/item/MpButton'
import MpDialog from '@/components/item/MpDialog'

export default {
  name: 'AdminMstBranchAdd',
  components: {
    MpLabel,
    MpInputBox,
    MpError,
    MpButton,
    MpDialog
  },
  data: () => ({
    companyId: null,
    view: {
      errors: []
    },
    form: {
      companyId: null,
      branchName: '',
      branchNameKana: ''
    },
    dialog: {
      registComplete: false
    }
  }),
  methods: {
    goCompanytDetail () {
      this.$router.push({ path: `/admin/mst/company/detail/${this.form.companyId}` })
    },
    async goRegister () {
      await AdminMstBranch.register(this.form)
        .then(() => { this.dialog.registComplete = true })
        .catch(error => { this.view.errors = error.messages })
    }
  },
  created: async function () {
    this.form.companyId = this.$route.params.companyId
  }
}
</script>
